const language = {
	spanish: {
		header_title: "Casos de ",
		header_span_title: "Éxito",
		title:
			"Foresight GPS contamos con un abanico de clientes que han reducido sus costos a través de nuestra innovación tecnológica y plataformas de rastreo.",
		card_button_text: "LEER CASO DE ÉXITO",
		final_button_text: "CARGAR MÁS CASOS DE ÉXITO",
	},
	english: {
		header_title: "Success ",
		header_span_title: "Stories",
		title:
			"Foresight GPS has a range of customers who have reduced their costs through our innovative technology and tracking platforms.",
		card_button_text: "READ SUCCESS STORY",
		final_button_text: "LOAD MORE SUCCESS STORIES",
	},
};

export default language;
